import React from 'react';

const Footer = () => {
  return (
    <section className="about-footer">
      <p>STEEM Burn Pool © 2024 | Delegation Pays, Supply Decays!</p>
      <p className="about-footer-small">Built on the Steem Blockchain | Powered by Community</p>
    </section>
  );
};

export default Footer;
